module.exports = __webpack_public_path__ + "media/markers/marker-yellow-7421783b.svg";